// @flow
import { getDayScheduleEvents, getSelectedDay, getSelectedEvent } from '~/core/state/ui/schedule/selectors';

import { connect } from 'react-redux';
import Slider from './component';

const mapStateToProps = (state, ownProps) => {
    const { componentId } = ownProps;
    const selectedDay = getSelectedDay(state, { componentId });
    const selectedEvent = getSelectedEvent(state, { componentId });
    const numEventsInSelectedDay = getDayScheduleEvents(state, {
        componentId,
        dayIndex: selectedDay
        // $FlowFixMe
    }).size;

    return {
        ...ownProps,
        numEventsInSelectedDay,
        selectedDay,
        selectedEvent
    };
};

// $FlowFixMe
export default connect(mapStateToProps)(Slider);



// WEBPACK FOOTER //
// ./src/components/widgets/schedule/slider/index.js